export const calculatePanelHeight = (status) => {
  status.panel.style.height = "auto";
  status.panel.height = status.panel.offsetHeight + "px";
  if (!status.visible) {
    status.panel.style.height = 0;
  }
};
